import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


/**
 * Rutas de navegación para el módulo de administración.
 */
const routes: Routes = [

  /**
   * Ruta para el módulo de login
   */
  {
    path: 'acceder',
    loadChildren: () => import('./login/login.module').then( m => m.LoginModule)
  },
  /**
   * Ruta para el módulo general
   */
  {
    path: 'ui',
    loadChildren: () => import('./mainframe/mainframe.module').then( m => m.MainframeModule),

  },
  //Para el resto de rutas, redirigimos a login
  {
    path: '**',
    loadChildren: () => import('./login/login.module').then( m => m.LoginModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
